/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateOperationalTaskCommentRequest } from '../models/create-operational-task-comment-request';
import { OperationalTask } from '../models/operational-task';
import { OperationalTaskComment } from '../models/operational-task-comment';
import { OperationalTasksResponsePage } from '../models/operational-tasks-response-page';
import { ResolveOperationalTaskRequest } from '../models/resolve-operational-task-request';


/**
 * Operational task queue for items requiring human attention
 */
@Injectable({
  providedIn: 'root',
})
export class OperationalTasksService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listOperationalTasks
   */
  static readonly ListOperationalTasksPath = '/operational-tasks';

  /**
   * List operational tasks.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listOperationalTasks()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOperationalTasks$Response(params?: {
    status?: 'OPEN' | 'RESOLVED';
    category?: string;
    reference_type?: string;
    reference_id?: number;
    limit?: number;
    after?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<OperationalTasksResponsePage>> {

    const rb = new RequestBuilder(this.rootUrl, OperationalTasksService.ListOperationalTasksPath, 'get');
    if (params) {
      rb.query('status', params.status, {});
      rb.query('category', params.category, {});
      rb.query('reference_type', params.reference_type, {});
      rb.query('reference_id', params.reference_id, {});
      rb.query('limit', params.limit, {});
      rb.query('after', params.after, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OperationalTasksResponsePage>;
      })
    );
  }

  /**
   * List operational tasks.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listOperationalTasks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOperationalTasks(params?: {
    status?: 'OPEN' | 'RESOLVED';
    category?: string;
    reference_type?: string;
    reference_id?: number;
    limit?: number;
    after?: string;
    context?: HttpContext
  }
): Observable<OperationalTasksResponsePage> {

    return this.listOperationalTasks$Response(params).pipe(
      map((r: StrictHttpResponse<OperationalTasksResponsePage>) => r.body as OperationalTasksResponsePage)
    );
  }

  /**
   * Path part for operation sendOperationalTaskTestAlert
   */
  static readonly SendOperationalTaskTestAlertPath = '/operational-tasks/test-alert';

  /**
   * Send a test alert.
   *
   * Creates an OPEN operational task in the `test_alert` category that references the caller (`reference_type` `user`, `reference_id` the caller's user id). The alert sender alerts it on every channel exactly as it alerts any other task, so the task's `notifications` show whether the alert channels work: each starts `pending` and turns into the channel's recorded outcome once the sender has handled it. Resolve the task once the alert has been received. Requires the `operational-tasks:test-alert` permission (403 otherwise).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendOperationalTaskTestAlert()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendOperationalTaskTestAlert$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<OperationalTask>> {

    const rb = new RequestBuilder(this.rootUrl, OperationalTasksService.SendOperationalTaskTestAlertPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OperationalTask>;
      })
    );
  }

  /**
   * Send a test alert.
   *
   * Creates an OPEN operational task in the `test_alert` category that references the caller (`reference_type` `user`, `reference_id` the caller's user id). The alert sender alerts it on every channel exactly as it alerts any other task, so the task's `notifications` show whether the alert channels work: each starts `pending` and turns into the channel's recorded outcome once the sender has handled it. Resolve the task once the alert has been received. Requires the `operational-tasks:test-alert` permission (403 otherwise).
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendOperationalTaskTestAlert$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendOperationalTaskTestAlert(params?: {
    context?: HttpContext
  }
): Observable<OperationalTask> {

    return this.sendOperationalTaskTestAlert$Response(params).pipe(
      map((r: StrictHttpResponse<OperationalTask>) => r.body as OperationalTask)
    );
  }

  /**
   * Path part for operation getOperationalTask
   */
  static readonly GetOperationalTaskPath = '/operational-tasks/{id}';

  /**
   * Get a single operational task.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOperationalTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOperationalTask$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<OperationalTask>> {

    const rb = new RequestBuilder(this.rootUrl, OperationalTasksService.GetOperationalTaskPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OperationalTask>;
      })
    );
  }

  /**
   * Get a single operational task.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getOperationalTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOperationalTask(params: {
    id: number;
    context?: HttpContext
  }
): Observable<OperationalTask> {

    return this.getOperationalTask$Response(params).pipe(
      map((r: StrictHttpResponse<OperationalTask>) => r.body as OperationalTask)
    );
  }

  /**
   * Path part for operation resolveOperationalTask
   */
  static readonly ResolveOperationalTaskPath = '/operational-tasks/{id}/resolve';

  /**
   * Mark a task as resolved.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resolveOperationalTask()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resolveOperationalTask$Response(params: {
    id: number;
    context?: HttpContext
    body?: ResolveOperationalTaskRequest
  }
): Observable<StrictHttpResponse<OperationalTask>> {

    const rb = new RequestBuilder(this.rootUrl, OperationalTasksService.ResolveOperationalTaskPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OperationalTask>;
      })
    );
  }

  /**
   * Mark a task as resolved.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resolveOperationalTask$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resolveOperationalTask(params: {
    id: number;
    context?: HttpContext
    body?: ResolveOperationalTaskRequest
  }
): Observable<OperationalTask> {

    return this.resolveOperationalTask$Response(params).pipe(
      map((r: StrictHttpResponse<OperationalTask>) => r.body as OperationalTask)
    );
  }

  /**
   * Path part for operation listOperationalTaskComments
   */
  static readonly ListOperationalTaskCommentsPath = '/operational-tasks/{id}/comments';

  /**
   * List comments on a task.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listOperationalTaskComments()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOperationalTaskComments$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<OperationalTaskComment>>> {

    const rb = new RequestBuilder(this.rootUrl, OperationalTasksService.ListOperationalTaskCommentsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OperationalTaskComment>>;
      })
    );
  }

  /**
   * List comments on a task.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listOperationalTaskComments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOperationalTaskComments(params: {
    id: number;
    context?: HttpContext
  }
): Observable<Array<OperationalTaskComment>> {

    return this.listOperationalTaskComments$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OperationalTaskComment>>) => r.body as Array<OperationalTaskComment>)
    );
  }

  /**
   * Path part for operation createOperationalTaskComment
   */
  static readonly CreateOperationalTaskCommentPath = '/operational-tasks/{id}/comments';

  /**
   * Add a comment to a task.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOperationalTaskComment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOperationalTaskComment$Response(params: {
    id: number;
    context?: HttpContext
    body: CreateOperationalTaskCommentRequest
  }
): Observable<StrictHttpResponse<OperationalTaskComment>> {

    const rb = new RequestBuilder(this.rootUrl, OperationalTasksService.CreateOperationalTaskCommentPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OperationalTaskComment>;
      })
    );
  }

  /**
   * Add a comment to a task.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createOperationalTaskComment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOperationalTaskComment(params: {
    id: number;
    context?: HttpContext
    body: CreateOperationalTaskCommentRequest
  }
): Observable<OperationalTaskComment> {

    return this.createOperationalTaskComment$Response(params).pipe(
      map((r: StrictHttpResponse<OperationalTaskComment>) => r.body as OperationalTaskComment)
    );
  }

  /**
   * Path part for operation retryPaymentFromTask
   */
  static readonly RetryPaymentFromTaskPath = '/operational-tasks/{id}/actions/retry-payment';

  /**
   * Resolve the task and retry the payment submission.
   *
   * Marks the task as resolved and sends a retrySubmission signal to the
   * associated Temporal workflow. Only valid for tasks with category 'payment_error'.
   *
   * Requires the `payments:retry` permission, the same one that gates
   * retrying the payment from the invoice page
   * (`POST /invoices/{invoice_id}/outgoing-payments/{payment_id}/retries`).
   * Without it the response is 403, the task stays open and the
   * workflow is not signalled.
   *
   * `error_code` values returned with `422`:
   *
   * - `financing_on_hold` — the payment's reason is
   *   `INVOICE_FINANCING` or `FINAL_PAYMENT` and at least one active
   *   financing hold applies to its invoice. The task stays open, no
   *   signal is sent and the payment's status is unchanged.
   *   `details.holds` is an array of `FinancingHold`: the active holds
   *   that apply, the same list as the invoice's `financing_holds`.
   * - `express_mismatch` — the payment's reason is `INVOICE_FINANCING` and
   *   its `is_express` differs from its invoice's `express_payment`, which
   *   can have changed since the payout was created. The task stays open, no
   *   signal is sent and the payment's status is unchanged. The message and
   *   `details.express_payment` are those of `createOutgoingPayment`'s
   *   `express_mismatch`; to send the payout the way the invoice is priced,
   *   create a new one. Final payments and payments with any other reason
   *   are not checked.
   *
   * A `422` without an `error_code` refuses an express payment whose
   * recipient's bank is not on the express allowlist, as creating it
   * would.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retryPaymentFromTask()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  retryPaymentFromTask$Response(params: {
    id: number;
    context?: HttpContext
    body?: ResolveOperationalTaskRequest
  }
): Observable<StrictHttpResponse<OperationalTask>> {

    const rb = new RequestBuilder(this.rootUrl, OperationalTasksService.RetryPaymentFromTaskPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OperationalTask>;
      })
    );
  }

  /**
   * Resolve the task and retry the payment submission.
   *
   * Marks the task as resolved and sends a retrySubmission signal to the
   * associated Temporal workflow. Only valid for tasks with category 'payment_error'.
   *
   * Requires the `payments:retry` permission, the same one that gates
   * retrying the payment from the invoice page
   * (`POST /invoices/{invoice_id}/outgoing-payments/{payment_id}/retries`).
   * Without it the response is 403, the task stays open and the
   * workflow is not signalled.
   *
   * `error_code` values returned with `422`:
   *
   * - `financing_on_hold` — the payment's reason is
   *   `INVOICE_FINANCING` or `FINAL_PAYMENT` and at least one active
   *   financing hold applies to its invoice. The task stays open, no
   *   signal is sent and the payment's status is unchanged.
   *   `details.holds` is an array of `FinancingHold`: the active holds
   *   that apply, the same list as the invoice's `financing_holds`.
   * - `express_mismatch` — the payment's reason is `INVOICE_FINANCING` and
   *   its `is_express` differs from its invoice's `express_payment`, which
   *   can have changed since the payout was created. The task stays open, no
   *   signal is sent and the payment's status is unchanged. The message and
   *   `details.express_payment` are those of `createOutgoingPayment`'s
   *   `express_mismatch`; to send the payout the way the invoice is priced,
   *   create a new one. Final payments and payments with any other reason
   *   are not checked.
   *
   * A `422` without an `error_code` refuses an express payment whose
   * recipient's bank is not on the express allowlist, as creating it
   * would.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `retryPaymentFromTask$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  retryPaymentFromTask(params: {
    id: number;
    context?: HttpContext
    body?: ResolveOperationalTaskRequest
  }
): Observable<OperationalTask> {

    return this.retryPaymentFromTask$Response(params).pipe(
      map((r: StrictHttpResponse<OperationalTask>) => r.body as OperationalTask)
    );
  }

}
